import React from 'react';
import EtelAPI from '../../../../api/EtelAPI.js';
import Alerts from '../../../../prototypes/Alerts.js';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import moment from 'moment';
import PageAuthorize from '../../../../security/PageAuthorize';
import ListContainer from '../../../../presentation/ListContainer';
import Lp247GrossMedSalesDialog from './Lp247GrossMedSalesDialog';
import layout from './Lp247GrossMedSales.json';

class Lp247GrossMedSalesList extends React.Component {
  constructor( props ) {
    super( props );
    
    this.EditModes = {
      VIEW: 0,
      INSERT: 1,
      UPDATE: 2
    };

    this.state = {
      rows: this.props.rows,
      showDialog: false,
      row: {},
      onUpdateItem: undefined,
      onInsertItem: undefined,
    };
  }

    // Handles exceptions
    onHandleException = ( e ) => {
      const title = 'LP247 Sales';
      const { bugsnag, dispatch} = this.props;
      const alerts = new Alerts( bugsnag, dispatch );
      const status = e.status === undefined ? 0 : e.status;
      if( status === 410 ) {
        alerts.INFO( title, 'Your session has expired.' , 5000 );
        this.doLogOff();
      } else if( status === 500 ) {
        alerts.WARNING( title, 'Server not available.', 5000 );
        this.doLogOff();
      } else if( status === 400 ) {
        alerts.CRITICAL( title, e.statusText );
      } else {
        alerts.CRITICAL( title, e );
      }
    }
    
  // Returns user back to the login page if creds fail
  doLogOff = ( ) => {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }
  
  onClickNewItem = ( args ) => { 
    const today = moment().subtract(1,'d').format("YYYY-MM-DD");
    let newRow = { DATE: today, SALES: 0, ADJUSTED_SALES: 0 };
    this.setState( { 
      showDialog: true,
      row: newRow,
      mode: this.EditModes.INSERT,
      reload: args.reload
    } );
  }

  onIconClicked = ( args ) => { 
    this.setState( { 
      showDialog: true,
      row: args.row,
      mode: this.EditModes.UPDATE,
      reload: args.reload
    } );
  }

  onSave = ( e ) => { 
    if( this.state.mode === this.EditModes.INSERT ) {
      this.onInsert( e.row );
    } else if( this.state.mode === this.EditModes.UPDATE ) {
      this.onUpdate( e.row );
    } else {
      this.setState( { 
        showDialog: false,
        mode: this.EditModes.VIEW,
        row: {}
      } );
    }
  }

  onInsert( row ) {
    let { bugsnag, dispatch } = this.props;
    let alert = new Alerts( bugsnag, dispatch );
    let api = new EtelAPI( 'accounting/lp247/sales' );
    let payload = { "DATE": row.DATE, "SALES": row.SALES, "ADJUSTED_SALES": row.ADJUSTED_SALES };
    api.insert( payload ).then( ( result ) => {
      alert.SUCCESS("LP247 Sales", "Successfully saved new LP247 Sale for " + row.DATE.toString(), 2500 );
      this.setState( { 
        showDialog: false,
        mode: this.EditModes.VIEW,
        row: {},
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  onUpdate = ( row ) => {
    let { bugsnag, dispatch } = this.props;
    let alert = new Alerts( bugsnag, dispatch );
    let api = new EtelAPI( 'accounting/lp247/sales' );
    let payload = { "DATE": row.DATE, "SALES": row.SALES, "ADJUSTED_SALES": row.ADJUSTED_SALES };
    api.update( payload ).then( ( result ) => {
      alert.SUCCESS("LP247 Sales", "Successfully updated LP247 Sale for " + row.DATE.toString(), 2500 );
      this.state.reload();
      this.setState( { 
        showDialog: false,
        mode: this.EditModes.VIEW,
        row: {},
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  onClose = ( e ) => { 
    this.setState( { 
      showDialog: false,
      row: {}
    } );
  }
  
  render(){
    return (
      <PageAuthorize groups={['Administrators','Operations','Accounting']}>
        <ListContainer
          id="Lp247GrossMedSalesList"
          layout={layout}
          selectedtab={1}
          onIconClicked={this.onIconClicked}
          onNewItem={this.onClickNewItem}
        />
        <Lp247GrossMedSalesDialog 
          show={this.state.showDialog} 
          rows={this.state.rows} 
          row={this.state.row} 
          mode={this.state.mode}
          onSave={this.onSave}
          onClose={this.onClose}
         />
      </PageAuthorize>
    );
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( Lp247GrossMedSalesList) 
);


// WEBPACK FOOTER //
// ./src/content/accounting/lp247/components/Lp247GrossMedSalesList.js